import React from 'react';
import spinnerPath from '../spinner.png';

export default function Spinner() {
    return (
        <img src={spinnerPath} alt="Cargando datos" className="spinner" />
    );
}
